import { ActivatedRoute, UrlSegment } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { PioneerUtils } from './pioneer-utils';

export class RouteUtils {
  static getLastUrlSegment(route: ActivatedRoute): Observable<UrlSegment | null> {
    return route.url.map((segments: UrlSegment[]) => {
      return PioneerUtils.getLastElement(segments);
    })
  }

  static getLastUrlSegmentSnapshot(route: ActivatedRoute): UrlSegment | null {
    const segments = route.snapshot.url;
    return PioneerUtils.getLastElement(segments);
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/UAT-GroupPay/workspace/pioneer-web/src/app/event/utils/route-utils.ts